const WhsLinkOperationStatus = {
  New: 1,
  Ready: 10,
  Linking: 50,
  Completed: 100,
  Error: 500
};

export default WhsLinkOperationStatus;
